<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="forms.length" class="list list-spaced rounded">
      <div class="flex py-2 font-medium text-sm bg-gray-200 uppercase text-gray-600">
        <div class="flex-1 px-4">Name</div>
      </div>

      <FormLine
        v-for="line in forms"
        :key="line.uuid"
        :form="line"
        @form-edit="editForm"
        @form-delete="confirmDeleteForm"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No forms found.</div>

    <template v-if="$membershipHasPermissionTo('edit forms')">
      <portal v-if="form && isActionEdit" to="app-dialog">
        <ModalEdit :form="form" @closed="resetAction" />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('edit projects')">
      <portal v-if="form && isActionDelete" to="app-dialog">
        <BaseDialogDelete
          danger
          :custom-classes="'max-w-md'"
          @closed="resetAction"
          @confirmed="$emit('form-delete', form.uuid)"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ModalEdit from '@/components/Forms/ModalEdit.vue';
import FormLine from './FormLine.vue';

const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    FormLine,
    ModalEdit,
  },

  props: {
    loading: Boolean,
    projectUuid: { type: String, required: true },
    forms: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/forms', ['form']),

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapMutations('ui/forms', ['setCurrent']),

    editForm(form) {
      this.setCurrent(form.uuid);
      this.action = ACTION_EDIT;
    },

    confirmDeleteForm(form) {
      this.setCurrent(form.uuid);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
